import { Box, Button } from "@mui/material";
import React, { useState } from "react";
import Select, { components } from "react-select";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import "./active-users.scss";
import ReactApexChart from "react-apexcharts";
import ApexCharts from "apexcharts";
import { ApexOptions } from "apexcharts";

interface ActiveUsersProps {
  series: any[];
  options: ApexOptions;
  title?: string;
  handleAddLeadReports: (data: any, params: any) => void;
  enableExport?: boolean;
}
const ActiveUsers: React.FC<ActiveUsersProps> = ({
  series,
  options,
  title,
  handleAddLeadReports,
  enableExport = false,
}) => {
  const [fileFormat, setFileFormat] = useState<any>({
    value: "pdf",
    label: "PDF",
  });
  const handleExport = async () => {
    try {
      const response = await ApexCharts.exec(
        "active-inactive-users",
        "dataURI"
      );
      handleAddLeadReports(
        { imageData: response?.imgURI.split(",")[1] },
        { section: "active-inactive-users", format: fileFormat.value }
      );
    } catch (error) {
      console.error("Error getting base64:", error);
    }
  };
  return (
    <div className="active-users-wrapper">
      <Box
        sx={{
          padding: "10px 20px",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <p className="header-text">{title}</p>
        <Box sx={{ display: "flex", gap: 1 }}>
          <Select
            options={[
              { value: "pdf", label: "PDF" },
              { value: "csv", label: "CSV" },
            ]}
            isSearchable={false}
            onChange={(e: any) => setFileFormat(e)}
            value={fileFormat}
            className="select-dropdown"
            components={{
              DropdownIndicator: (props) => {
                return (
                  <components.DropdownIndicator {...props}>
                    <ArrowDropDownIcon
                      style={{ fontSize: 20, color: "black" }}
                    />
                  </components.DropdownIndicator>
                );
              },
              IndicatorSeparator: () => null,
            }}
          />
          <Button
            variant="outlined"
            onClick={handleExport}
            className="address-edit-button"
            disabled={!enableExport}
          >
            Export
          </Button>
        </Box>
      </Box>
      {series?.length ? (
        <Box sx={{ padding: "0px 20px" }}>
          <ReactApexChart
            options={options}
            series={series}
            type="donut"
            height={250}
            id="active-inactive-users"
          />
        </Box>
      ) : (
        <Box sx={{ padding: "0px 20px", textAlign: "center", height: "100px" }}>
          <p>No data available</p>
        </Box>
      )}
    </div>
  );
};

export default ActiveUsers;
